(function() {

    function getData(params) {
        var data = {};

        params.forEach(function(param) {
            data[param] = $('[name=' + param + ']').val();
        });

        return data;
    }

    $('input[data-tagsinput]').each(function() {
        var url = $(this).data('tagsinput-url');
        var params = $(this).data('tagsinput-params');

        if (params) {
            params = params.split(',');
        }

        if (url) {
            $(this).tagsinput({
              typeaheadjs: {
                async: true,
                limit: 999,
                minLength: 1,
                name: 'tags',
                displayKey: 'name',
                valueKey: 'name',
                source: function(query, sync, async) {
                    $.get(url.replace('%QUERY', query), getData(params), function(data) {
                        return async(data);
                    });
                }
              }
            });
        } else {
            $(this).tagsinput();
        }
    });

})();